import React, { useState } from 'react';
import styled from 'styled-components';
import { IoIosArrowDown } from "react-icons/io";


const InputContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 400px;
  position: relative;
  border: 1px solid ${props => props.error ? '#CF0909' : '#cfd8dd'};
  border-radius: 8px;
  overflow: hidden;
  height: 38px;
`;

const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  transition: all 0.3s;
  background: white;

  &:focus-within {
    border-color: ${props => props.error ? '#CF0909' : '#1890ff'};
    box-shadow: 0 0 0 2px ${props => props.error ? 'rgba(207, 9, 9, 0.08)' : 'rgba(24, 144, 255, 0.2)'};
  }
`;

const IconWrapper = styled.div`
  padding: 0 8px;
  color: #1890ff;
  display: flex;
  align-items: center;
  position: absolute;
  right: 2px;
  background: #fff;
  width: 29px;
  height: 25px;
  z-index: 2;
  pointer-events: none;
  user-select: none;
`;

const Input = styled.input`
  width: 100%;
  height: 40px;
  padding: 4px 11px;
  border: none;
  outline: none;
  font-size: 16px;

  &::placeholder {
    color: #bfbfbf;
  }
`;

const SelectWrapper = styled.div`
  position: relative;
  min-width: 100px;
`;
const SelectItemWrapper = styled.div`
display: flex;
flex-direction: column;
grid-row-gap: 4px;
label{
color: #7E8A90;
font-weight: 400;
font-size: 12px;
line-height: 16px;
letter-spacing: 0%;
}

`;
const Select = styled.select`
  width: 100%;
  height: 40px;
  padding: 4px 11px;
  border: none;
  outline: none;
  background: transparent;
  cursor: pointer;
  appearance: none;
  font-size: 16px;
`;

const SelectArrow = styled.div`
  position: absolute;
  right: 11px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  border-style: solid;
  border-width: 5px 4px 0 4px;
  border-color: #999 transparent transparent transparent;
`;

const SelectInput = ({
  defaultDomain = 'oz',
  defaultExtension = 'oz',
  onDomainChange,
  onExtensionChange,
  extensions
}) => {
  const [domain, setDomain] = useState(defaultDomain);
  const [extension, setExtension] = useState(defaultExtension);

  const handleDomainChange = (e) => {
    setDomain(e.target.value);
    onDomainChange?.(e.target.value);
  };

  const handleExtensionChange = (e) => {
    setExtension(e.target.value);
    onExtensionChange?.(e.target.value);
  };

  return (
    <SelectItemWrapper>
      <label>Weight</label>
    <InputContainer>
      <InputWrapper>
        <IconWrapper>
          <IoIosArrowDown size={16} />
        </IconWrapper>
        <Input
          value={domain}
          onChange={handleDomainChange}
          placeholder="Enter"
        />
        <SelectWrapper>
          <Select value={extension} onChange={handleExtensionChange}>
            {extensions.map((ext) => (
              <option key={ext} value={ext}>
                {ext}
              </option>
            ))}
          </Select>
          <SelectArrow />
        </SelectWrapper>
      </InputWrapper>
    </InputContainer>
    </SelectItemWrapper>

  );
};

export default SelectInput;